import React from 'react'

import { useTranslation } from 'react-i18next'

import ExternalLink from '@components/shared/ExternalLink'
import { useTitle } from '@providers/TitleProvider'

const AudioReference: React.FC = () => {
  const {
    title: {
      metadata: { audio_reference_path },
    },
  } = useTitle()
  const { t } = useTranslation()

  if (!audio_reference_path) return null

  return (
    <ExternalLink className="text-orange flex items-center text-md" href={audio_reference_path}>
      <i className="nf-icon nf-speaker mr-2 text-xl" />
      <span>{t('content.referenceAudio')}</span>
    </ExternalLink>
  )
}

export default AudioReference
